import React, { useEffect } from 'react';
import HeadphoneProductForm from './HeadphoneProductMISCForm'
import { Paper, withStyles } from "@material-ui/core";
import { hasPermission, parseURL } from '../../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "../store/headphoneProductActions";
import {getProductType} from "../../../sc-admin/SystemCertificate/utils";

const styles = theme => ({
    root: {
        width: `100%`,
        height: 'auto',
        marginTop: '-43px',
        [theme.breakpoints.down('md')]: {
            marginTop: '-21px',
            width: '100%'
        },
        [theme.breakpoints.down('sm')]: {
            marginTop: '-21px',
            width: '100%'
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const HeadphoneProductEditMisc = props => {
    const { product, loading, editable, classes, activeCustomer, translations, permissions, onFetchHeadphoneProduct } = props;
    let searchParams = parseURL(window.location.search);

    const handleSubmit = async data => {
        data['ActiveCustomerID'] = activeCustomer;
        data['updateMISCOnly'] = true;
        data['ProductID'] = searchParams?.productID;
        await props.onEditHeadphoneProduct({ ...data });
    }

    const getSecurazeVersion = (processingSession) => {
        if (processingSession?.ClientType) {
            return `${getProductType(processingSession?.ClientType ?? "", translations)}: ${processingSession?.ClientVersion ?? ""}`;
        }
        return processingSession?.ClientVersion ?? "";
    }

    let initialValues = {
        OperatingSystemVersion: product && product.HeadphoneProduct && product.HeadphoneProduct.OperatingSystemVersion ? product.HeadphoneProduct.OperatingSystemVersion : '',
        DeviceColor: product && product.HeadphoneProduct && product.HeadphoneProduct.DeviceColor ? product.HeadphoneProduct.DeviceColor : '',
        ReleaseYear: product && product.HeadphoneProduct && product.HeadphoneProduct.ReleaseYear ? product.HeadphoneProduct.ReleaseYear : '',
        OemStatus: product && product.HeadphoneProduct && product.HeadphoneProduct.OemStatus ? product.HeadphoneProduct.OemStatus : '',
        OemReason: product && product.HeadphoneProduct && product.HeadphoneProduct.OemReason ? product.HeadphoneProduct.OemReason : '',
        ProductIdentifier: product && product.HeadphoneProduct && product.HeadphoneProduct.ProductIdentifier ? product.HeadphoneProduct.ProductIdentifier : '',
        ANumber: product && product.HeadphoneProduct && product.HeadphoneProduct.ANumber? product.HeadphoneProduct.ANumber : '',
        SecurazeVersion: getSecurazeVersion(product?.ProcessingSessions?.[0]),
        HardwareID: product && product.HardwareID ? product.HardwareID : '',
    };

    let formSettings = {
        Validation: {
        },
        ButtonSubmit: hasPermission(permissions, "product_save")
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null,
    };

    useEffect(() => {
        const getProduct = async () => {
            await onFetchHeadphoneProduct({ActiveCustomerID: activeCustomer, ProductID: searchParams?.productID});
        }
        getProduct();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (<>< Paper className={classes.root} >
                <HeadphoneProductForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    editable={editable}
                    loading={loading}
                    translations={translations}
                ></HeadphoneProductForm>
            </Paper>
        </>)
}

const mapStateToProps = state => {
    return {
        product: state?.product?.headphoneProducts?.loaded,
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onEditHeadphoneProduct: product => dispatch(actions.editHeadphoneProduct(product)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(HeadphoneProductEditMisc));
